import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import selectHelper from '../../../Helpers/selectHelper';
import SurveyDatumItem from '../../../Domain/SurveyDatumItem';
import SurveyDatumService from '../../../Services/SurveyDatumService';

// Drives the GeneralEditWizzardBaseFigma edit wizard for surveys. Single page
// with <=6 fields renders as the compact centered DS modal.
export default class SurveyWindowDescription {
  static titleForCreate = 'Add New Survey';
  static titleForEdit = 'Edit Survey';
  static entityName = 'Survey';
  static idField = 'SurveyDataId';
  static nameField = 'SurveyId';
  static itemType = SurveyDatumItem;
  static serviceFunction = SurveyDatumService.EditSurveyDatum;
  static messageOnSuccess = 'Survey has been saved.';
  static finishButtonLabel = 'Save Survey';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'SurveyId',
          label: 'Survey Id',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ShopperId',
          label: 'Shopper Id',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IsActive',
          label: 'Is Active',
          className: 'col-6',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Emailrecipients',
          label: 'Email Recipients',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Target',
          label: 'Target',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: () => SurveyWindowDescription.getTargetSelectValues(),
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'OfficialShopDateSassieQuestionId',
          label: 'Official Shop Date Sassie Question Id',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    },
  ];

  static getTargetSelectValues() {
    return selectHelper.generateSelectValues(['', 'Apollo', 'Caspian']);
  }
}
